<template>
    <card xs-tile sm-tile class="flex-grow-1">
        <div v-if="page.content" class="border-b p-16">
            <user-content :text="page.content" />
        </div>
        <template v-if="galleries.length">
            <gallery-card v-for="gallery in galleries" :key="gallery.id" :gallery="gallery" :to="$app(`events-event-photos-gallery`, {params: {event: eventStore.event._key, gallery: gallery._key}, state: {gallery_ts: $date(gallery.updated_at).unix()}})" flat tile no-spacing class="divided"/>
        </template>
        <missing-info v-else :text="$t('missing.media.index')" no-spacing/>
    </card>
</template>

<script setup lang="ts">

import {useEventStore} from "../../../../store/event";

const eventStore = useEventStore();
const {t} = useI18n();

const {data: {galleries, page}} = await useApiFetch(`/v1/view/events/${eventStore.event.id}/galleries`, {
	guest: true
})

useMeta({
	title: eventStore.buildPageTitle(t('view.events.media.index.title', {event: eventStore.event.display_name})),
	description: t('view.events.media.index.description', {event: eventStore.event.display_name})
})

</script>

